import React from "react";
import HomePage from "./HomePage";

function Homenew() {
  return <HomePage />;
}

export default Homenew;
